import axios from "axios"

const getBodyFormData = ({
  categoriaPadreId,
  nombre,
  imageFile,
}: $TSMigrationFixMe) => {
  const bodyFormData = new FormData()
  bodyFormData.append("nombre", nombre)

  if (categoriaPadreId) {
    bodyFormData.append("categoriaPadreId", categoriaPadreId)
  }

  if (imageFile) {
    bodyFormData.append("FileAsFormFile", imageFile)
  }

  return bodyFormData
}

const CategoriaService = {
  getAllPadres() {
    return axios.get("/Categoria/padres")
  },

  getAllPadresByNif(NIF: $TSMigrationFixMe) {
    return axios.get(`/Categoria/padres-by-nif/${NIF}`)
  },

  post({ categoriaPadreId, imageFile, nombre }: $TSMigrationFixMe) {
    const bodyFormData = getBodyFormData({
      categoriaPadreId,
      nombre,
      imageFile,
    })

    return axios({
      method: "post",
      url: `/Categoria`,
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data" },
    })
  },

  put({
    categoriaPadreId,
    imageFile,
    nombre,
    id,
    ficheroId,
  }: $TSMigrationFixMe) {
    const bodyFormData = getBodyFormData({
      categoriaPadreId,
      nombre,
      imageFile,
    })

    bodyFormData.append("id", id)
    if (!imageFile && ficheroId) {
      bodyFormData.append("FicheroId", ficheroId)
    }

    return axios({
      method: "put",
      url: `/Categoria`,
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data" },
    })
  },

  delete(id: $TSMigrationFixMe) {
    return axios.delete(`/Categoria/${id}`)
  },

  getPosiblesCategoriasPadreByCategoriaId(categoriaId: $TSMigrationFixMe) {
    return axios.get(`/Categoria/possible-categorias-padre/${categoriaId}`)
  },

  getAll() {
    return axios.get("/Categoria/items")
  },

  getById(categoriaId: $TSMigrationFixMe) {
    return axios.get(`/Categoria/${categoriaId}`)
  },

  getByCategoriasId(categoriasId = []) {
    // @ts-expect-error TS(2345): Argument of type 'TemplateStringsArray' is not ass...
    const categoriasIdString = categoriasId.map(({ id }) => `ids=${id}`).join`&`
    return axios.get(`/Categoria/by-ids?${categoriasIdString}`)
  },
}

export default CategoriaService
